import { Box, Pagination as PaginationComponent } from '@mui/material';
import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number | undefined;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages = 0, onChange }: PaginationProps) {
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onChange(value);
  };
  if (totalPages <= 1) {
    return null;
  }
  return (
    <Box display='flex' justifyContent='flex-end' mt={3}>
      <PaginationComponent
        count={totalPages}
        shape='rounded'
        color='primary'
        page={currentPage}
        onChange={handleChange}
      />
    </Box>
  );
}
